import { Menu } from 'antd';
import classNames from 'classnames';
import useMenuItemNavigator from '@Components/AccordionSideMenu/hook/useMenuItemNavigator';
import { items } from '../items/DashboardMenuItems';

import styles from './accordion-side-menu.module.css';

const DashboardMenu: React.FC = () => {
  const { menuItemNavigate } = useMenuItemNavigator();
  return (
    <Menu
      mode="horizontal"
      defaultOpenKeys={['menuItem1']}
      items={items}
      className={classNames(
        styles.accordionSideMenu,
        'mobile-dashboard-menu-view',
        'trojan-glassphormism-box trojan-glassphormism-box-shadow'
      )}
      onClick={(event) => {
        menuItemNavigate(event.key);
      }}
      //   onSelect={({ selectedKeys }) => setSelectedItem(selectedKeys)}
    />
  );
};

export default DashboardMenu;
